
export enum AssetTypes {
	Blueprint = "Graph",
	Form = "Form",
	Gallery = "Gallery",
}